{
  "name": "sinsc-publico",
  "version": "2.4.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "dev": "ng serve --port 4300 --configuration=localhost",
    "docker": "ng build --configuration=dev --output-path=dist/ --source-map --base-href=/",
    "build": "ng build",
    "watch": "ng build --watch --configuration=localhost",
    "test": "ng test",
    "lint": "ng lint --fix",
    "homolog": "ng build --configuration=homolog --output-path=dist/ --base-href /",
    "homolog-vm": "ng build --configuration=homolog-vm --output-path=dist/ --base-href /",
    "production": "ng build --configuration=production --output-path=dist/ --base-href /",
    "nuvem": "ng build --configuration=nuvem --output-path=dist/ --source-map --base-href /"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "^21.2.0",
    "@angular/compiler": "^21.2.0",
    "@angular/core": "^21.2.0",
    "@angular/forms": "^21.2.6",
    "@angular/platform-browser": "^21.2.0",
    "@angular/platform-browser-dynamic": "^21.2.6",
    "@angular/router": "^21.2.6",
    "@angular/service-worker": "^21.2.6",
    "@grafana/faro-web-sdk": "^2.3.1",
    "@grafana/faro-web-tracing": "^2.3.1",
    "@ng-select/ng-select": "^21.7.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@opentelemetry/instrumentation": "^0.212.0",
    "@opentelemetry/instrumentation-document-load": "^0.57.0",
    "@opentelemetry/instrumentation-fetch": "^0.212.0",
    "@opentelemetry/instrumentation-user-interaction": "^0.56.0",
    "@opentelemetry/instrumentation-web-exception": "^0.5.0",
    "@opentelemetry/instrumentation-xml-http-request": "^0.212.0",
    "@opentelemetry/resources": "^2.5.0",
    "@opentelemetry/sdk-logs": "^0.212.0",
    "@opentelemetry/sdk-trace-web": "^2.6.1",
    "@opentelemetry/semantic-conventions": "^1.40.0",
    "bootstrap": "^5.3.8",
    "bootstrap-icons": "^1.13.1",
    "ngx-mask": "^21.0.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.8.1",
    "zone.js": "^0.16.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "21.3",
    "@angular/build": "^21.2.5",
    "@angular/cli": "^21.2.5",
    "@angular/compiler-cli": "^21.2.6",
    "@eslint/js": "^10.0.1",
    "@types/bootstrap": "^5.2.10",
    "angular-eslint": "21.3",
    "eslint": "^10.1.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.5",
    "jsdom": "^29.0.1",
    "prettier": "^3.8.1",
    "typescript": "5.9",
    "typescript-eslint": "^8.57.2",
    "vitest": "^4.1.2"
  },
  "overrides": {
    "undici": "7.24.5"
  }
}
